// api_gateway trả lỗi gRPC của fulfillment_be qua errors[].extensions.details (xem ErrorPresenter của gateway):
// ErrorInfo { reason, metadata: { project_code, project_field, project_data } } và BadRequest { field_violations }.

const parseJSON = (raw) => {
  if (typeof raw !== "string") return raw ?? null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const detailsOf = (gqlError) => {
  const details = gqlError?.extensions?.details;
  return Array.isArray(details) ? details.filter((item) => item && typeof item === "object") : [];
};

/** Lấy lỗi GraphQL đầu tiên từ ApolloError, lỗi reject hoặc mảng errors trả kèm data (errorPolicy=all). */
export const firstGraphQLError = (errorOrErrors) => {
  if (Array.isArray(errorOrErrors)) return errorOrErrors[0] || null;
  return errorOrErrors?.graphQLErrors?.[0] || null;
};

/** HTTP status của lỗi mạng (vd 401) nếu có. */
export const networkStatusOf = (error) => error?.networkError?.statusCode ?? error?.networkError?.response?.status;

/**
 * Chuẩn hoá một lỗi GraphQL thành { code, message, fields: [{ field, message }], data }.
 * Trả null nếu không phải lỗi GraphQL (vd lỗi mạng).
 */
export const parseGraphQLError = (gqlError) => {
  if (!gqlError) return null;
  const details = detailsOf(gqlError);
  const info = details.find((item) => typeof item.reason === "string" && item.reason);
  const metadata = info?.metadata || {};
  const fields = [];
  details.forEach((item) => {
    const violations = item.field_violations || item.fieldViolations;
    if (Array.isArray(violations)) {
      violations.forEach((violation) => {
        if (violation?.field) fields.push({ field: violation.field, message: violation.description || "" });
      });
    }
  });
  if (!fields.length && metadata.project_field) {
    fields.push({ field: metadata.project_field, message: gqlError.message || "" });
  }
  return {
    code: metadata.project_code || info?.reason || gqlError.extensions?.code || null,
    message: gqlError.message || "",
    fields,
    data: parseJSON(metadata.project_data),
  };
};
